import { type AxiosResponse } from 'axios'
import { IPromotionsAndTotals } from "@/interface/services/response/promotion.interface"
import { useAbortController } from '@/composables/useAbortController'
import MyAxios from '@/api/axios'

export default
{
    async getPromotionsFromContracts(ids: number[]): Promise<IPromotionsAndTotals> {
        const { getSignal } = useAbortController()
        const url = `/promotions/by-contract`
        return await MyAxios.get(url, { ignoreGlobalLoader: true, params: { contracts: ids }, signal: getSignal() }).then(
            (response: AxiosResponse<IPromotionsAndTotals>) => response.data
        );
    },
}
